export default __webpack_public_path__ + "static/media/wallpaper-6.5ac4e86c.png";